import SectionTitle from '../../../../components/SectionTitle/SectionTitle'
export default function AboutUsMobile({ firstImage, secondImage, title, subtitleTag, subtitle }) {
   return (
      <>
         <div className='aboutUs-text-container'>
            < SectionTitle upText={subtitleTag} downText={title} />
         </div>
         <div className='aboutUs-pictures-container'>
            <div className='aboutUs-image-container'>
               <img className='aboutUs-image' src={firstImage} alt='perro contento' />
               <img className='aboutUs-image' src={secondImage} alt='perro contento' />
            </div>
         </div>
         <p className='aboutUs-paragraph'>{subtitle}</p>
      </>
   )
}
